import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import app from './modules/app';
import theme from './modules/theme';
import user from './modules/user';
import typist from './modules/typist';
import consult from './modules/consult';
import proposal from './modules/proposal';
import retract from './modules/retract';
import contract from './modules/contract';

Vue.use(Vuex);

const persist = new VuexPersistence({
  key: 'vuex',
  storage: window.localStorage,
  reducer: (state) => ({
    retract: state.retract,
    app: state.app,
    consult: state.consult,
    proposal: state.proposal,
    contract: state.contract,
  }),
});

export default new Vuex.Store({
  plugins: [persist.plugin],
  modules: {
    app: {
      namespaced: true,
      ...app,
    },
    consult: {
      namespaced: true,
      ...consult,
    },
    theme: {
      namespaced: true,
      ...theme,
    },
    user: {
      namespaced: true,
      ...user,
    },
    typist: {
      namespaced: true,
      ...typist,
    },
    proposal: {
      namespaced: true,
      ...proposal,
    },
    retract: {
      namespaced: true,
      ...retract,
    },
    contract: {
      namespaced: true,
      ...contract,
    },
  },
});
